import React from "react";
import Card from "components/Card/Card";
import { useParams } from "react-router-dom";
import Page from "components/Page/Page";
import UpdateServiceForm from "./components/UpdateServiceForm";
import DetailSelector from "./components/DetailSelector";

const ServiceDetails = () => {
  const { id } = useParams();

  return (
    <Page>
      <Card
        title="View Service Details"
        subTitle={id ? `Service id: ${id}` : "Following are the details"}
      >
        <UpdateServiceForm />
        <DetailSelector />
      </Card>
    </Page>
  );
};

export default ServiceDetails;
